import React from "react";
import { Button, DialogActions, Dialog, DialogContent } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const styles = {
  actions: {
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
};


/* ======================================== COMPONENT ======================================== */

const WithDialog = ({ component, children }) => {
  const history = useHistory();
  
  const [isOpen, setIsOpen] = React.useState(false);
  const openDialog = React.useCallback((e) => {
    e.stopPropagation();
    setIsOpen(true);
  }, [setIsOpen]);
  const closeDialog = React.useCallback((e) => {
    e.stopPropagation();
    setIsOpen(false);
  }, [setIsOpen]);

  //Close dialog on route change
  React.useEffect(() => {
    return history.listen(() => {
      setIsOpen(false);
    });
  }, [history]);


  return (
    <React.Fragment>
      {React.cloneElement(component, { onClick: openDialog })}
      <Dialog
        open={isOpen}
        onClose={closeDialog}
        disableScrollLock={true}
        fullWidth
        maxWidth={"sm"}
      >
        <DialogContent>
          {children}
        </DialogContent>
        <DialogActions style={styles.actions}>
          <Button onClick={closeDialog}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default WithDialog;
